import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import RCAQuotation from './RCAQuotation';
import { Card } from '@totalsoft/rocket-ui';
import { BookmarkBorder } from '@mui/icons-material';

const sortQuotations = quotations => {
  const sourceQuotations = quotations.filter(x => !x.sourceInsuranceQuotationId);
  const negotiatedQuotations = quotations.filter(x => x.sourceInsuranceQuotationId);

  const newQuotations = [];
  negotiatedQuotations.forEach(quotation => {
    const sourceQuotation = sourceQuotations.find(x => x.id === quotation.sourceInsuranceQuotationId);
    if (sourceQuotation) {
      newQuotations.push(sourceQuotation);
      newQuotations.push(quotation);
    }
  });

  sourceQuotations.forEach(quotation => {
    if (!negotiatedQuotations.some(x => x.sourceInsuranceQuotationId === quotation.id)) newQuotations.push(quotation);
  });
  return newQuotations;
};

const RCAQuotationsByDuration = ({ quotations, isReadOnly }) => {
  const { t } = useTranslation();
  const sortedQuotations = useMemo(() => sortQuotations(quotations), [quotations]);

  return (
    <Card
      id={'rcaInsuranceContainer'}
      icon={BookmarkBorder}
      title={
        quotations[0]?.period === 1
          ? t('Offer.Insurance.ValabilityInfoOneMonth', {
              monthNo: quotations[0]?.period
            })
          : t('Offer.Insurance.ValabilityInfo', {
              monthNo: quotations[0]?.period
            })
      }
    >
      <Grid container spacing={1}>
        {sortedQuotations.map(quotation => (
          <RCAQuotation key={quotation.id} quotation={quotation} isReadOnly={isReadOnly} />
        ))}
      </Grid>
    </Card>
  );
};

const customValidationPropQuotations = (props, propName) => {
  if (!props[propName] || props[propName].length === 0)
    return new Error(
      'Failed prop type: The prop `quotations` is marked as required in `RCAQuotationsByDuration`, but its value is `' +
        typeof props[propName] +
        '`. The collection should have at least one item.'
    );
};

RCAQuotationsByDuration.propTypes = {
  quotations: customValidationPropQuotations,
  isReadOnly: PropTypes.func.isRequired
};

export default RCAQuotationsByDuration;
